import React from "react";
import { useEffect } from "react";
import { getRequests, statusCount } from "../actions/messageActions";
import OrderRequestsAdmin from "../components/Admin/OrderRequestsAdmin";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../helpers/Loading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AiFillFileAdd } from "react-icons/ai";
import DisplayProductsAdmin from "../components/Admin/DisplayProductsAdmin";
import { getProducts } from "../actions/storeActions";
import AddInventoryModal from "../components/Admin/AddInventoryModal";
import ViewRequestModal from "../components/Admin/ViewRequestModal";
import { checkIfAdmin } from "../actions/adminActions";
import CreateAnnouncement from "../components/Admin/CreateAnnouncement";

const Admin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const table_data = useSelector((state) => state.messageDetail);

  const product_detail = useSelector((state) => state.productDetail);

  const { state, pathname } = useLocation();

  const [tableData, setTableData] = useState({
    message: null,
    dish: null,
    goods: null,
  });

  useEffect(() => {
    (async function getCountsAndRequests() {
      const { data } = await getRequests();

      const {
        data: { dish, goods },
      } = await getProducts();
      const dataCounts = await statusCount();
      const { Read, Completed, Pending } = dataCounts;
      dispatch({
        type: "TABLE_DATA_WITH_MESSAGE_STATUS",
        payload: {
          message: data,
          dish: dish,
          goods: goods,
          Read: Read ? Read : 0,
          Completed: Completed ? Completed : 0,
          Pending: Pending ? Pending : 0,
        },
      });

      setTableData({
        dish: dish?.reverse(),
        message: data?.reverse(),
        goods: goods?.reverse(),
      });
    })();
  }, []);

  useEffect(() => {
    (async function check() {
      const data = await checkIfAdmin();
      if (!data.isAdmin) {
        navigate("/login", {
          state: {
            message: "Forbidden",
          },
        });
      }
    })();
  }, []);
  //message because message only have the auth process
  if (table_data.table_data?.message === undefined) return <Loading />;

  return (
    <div className="admin_body">
      <div className="menu">
        <button
          className="add_btn"
          onClick={() =>
            dispatch({ type: "OPEN_ADD_PRODUCT_MODAL", payload: true })
          }
        >
          <AiFillFileAdd />
        </button>
      </div>
      <button
        className="set_announcement_btn"
        onClick={() =>
          dispatch({ type: "OPEN_ADD_ANNOUNCEMENT_MODAL", payload: true })
        }
      >
        📢
      </button>
      {/* <ToastContainer
        autoClose={3000}
        toastStyle={{ backgroundColor: "green", color: "white" }}
      /> */}
      <CreateAnnouncement open={table_data.announce_modal} />
      <ViewRequestModal
        open={table_data.request_modal_open}
        data={table_data.orderData}
      />

      <AddInventoryModal open={product_detail.product_modal} />
      <OrderRequestsAdmin tableData={table_data.table_data} />
      <DisplayProductsAdmin
        tableData={table_data.table_data.dish}
        headerTitle="Daily Dishes"
        tableHeaders={[
          "Pieces",
          "Dish",
          "Price",
          "A-Points",
          "Status",
          "Discount",
          "Actions",
        ]}
        category="dish"
      />
      <DisplayProductsAdmin
        tableData={table_data.table_data.goods}
        headerTitle="Products/Goods"
        tableHeaders={[
          "Pcs",
          "Product",
          "Price",
          "A-Points",
          "Status",
          "Discount",
          "Actions",
        ]}
        category="goods"
      />
    </div>
  );
};

export default Admin;
